export default "__VITE_ASSET__DteNp1se__"